import React from "react";
import "./TagCard.css";

interface ITagCardProps {
  label: string;
  value: string;
  onRemove: () => void;
}

const TagCard: React.FC<ITagCardProps> = ({ label, value, onRemove }) => {
  return (
    <div className="tag-card-container">
      <span className="tag-card-label">{label}</span>
      <div className="tag-card">
        <span className="tag-card-value">{value}</span>
        <button 
          className="tag-card-remove" 
          onClick={onRemove}
          aria-label={`Remove ${label} filter`}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default TagCard;
